export default __webpack_public_path__ + "static/media/tpp-satisfaction-guarantee.02868196.svg";